export default __webpack_public_path__ + "static/media/unique13.e5177305.PNG";